<!--
 * @Author: your name
 * @Date: 2020-04-03 17:48:47
 * @LastEditTime: 2021-01-14 11:36:32
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \shopManagement\src\components\basic\goodsmanage\basic-info.vue
-->
<template>
  <div class="basic-info">
    <el-form label-position="left" label-width="80px" :model="formLabelAlign">
      <el-form-item label="商品编码">
        <el-input v-model="formLabelAlign.self_code"></el-input>
      </el-form-item>
      <el-form-item label="锐锢商城编码">
        <el-input v-model="formLabelAlign.ruigu_code" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="商品名称">
        <el-input v-model="formLabelAlign.name" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="规格型号">
        <el-input v-model="formLabelAlign.spec" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="所属分类">
        <el-input v-model="formLabelAlign.c_name" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="所属品牌">
        <el-input v-model="formLabelAlign.b_name" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="最小起订量">
        <el-input v-model="formLabelAlign.start_sell" :disabled="true"></el-input>
      </el-form-item>
      <!-- <el-form-item label="经营属性">
        <el-input v-model="formLabelAlign.type" :disabled="true"></el-input>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" size="small" @click="saveGoods">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { updateGoods } from '@/models/goodsModel'
export default {
  inject: ['reload'],
  data () {
    return {
      formLabelAlign: {
        name: '',
        ruigu_code: '',
        self_code: '',
        spec: '',
        b_name: '',
        c_name: '',
        start_sell: ''
      }
    }
  },

  created () {
    this.$nextTick(() => {
      this.formLabelAlign = JSON.parse(localStorage.getItem('editGoodsData'))
    })
  },
  methods: {
    async saveGoods () {
      let params = {
        self_code: this.formLabelAlign.self_code,
        id: this.formLabelAlign.id
      }
      let data = await updateGoods(params)
      if (data.message === 'Success') {
        this.$message.success('保存成功')
        this.reload()
      }
    }
  }
}
</script>
<style lang="scss">
.basic-info {
  .el-input {
    width: 400px !important;
  }
  .el-button {
    // width: 100px;
    // height: 35px;
    margin: 20px 140px;
    line-height: 10px;
  }.el-form-item {
    margin-bottom:0px;
  }
  .el-form-item__label {
    width: 120px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/basic/goodsmanage/basic-info.vue